import { Pipe, PipeTransform } from '@angular/core';

export enum enumLicenseStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  EXPIRED = 'EXPIRED',
  NOT_FOUND = 'NOT_FOUND',
  ERROR = 'ERROR',
}

@Pipe({
  name: 'licenseStatus',
  standalone: false,
})
export class LicenseStatusPipe implements PipeTransform {
  transform(value: enumLicenseStatus | string): string {
    return getLicenseStatusLabel(value);
  }
}

export const getLicenseStatusLabel = (value: enumLicenseStatus | string): string => {
  const statusMap: Record<string, string> = {
    [enumLicenseStatus.ACTIVE]: 'Attiva',
    [enumLicenseStatus.INACTIVE]: 'Inattiva',
    [enumLicenseStatus.EXPIRED]: 'Scaduta',
    [enumLicenseStatus.NOT_FOUND]: 'Non trovata',
    [enumLicenseStatus.ERROR]: 'Errore',
  };

  return statusMap[value] || value;
};
